// extracted by mini-css-extract-plugin
export default {"timeBlock":"clockTimer_timeBlock__vkySz","timerNumber":"clockTimer_timerNumber__aMY5D"};